export const REQUEST_SERVICE_LEVEL_SPECIALTIES_DATA = 'REQUEST_SERVICE_LEVEL_SPECIALTIES_DATA';
export const RECEIVE_SERVICE_LEVEL_SPECIALTIES_DATA = 'RECEIVE_SERVICE_LEVEL_SPECIALTIES_DATA';

export const receiveServiceLevelSpecialtiesData = (payload) => ({
  type: RECEIVE_SERVICE_LEVEL_SPECIALTIES_DATA,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/serviceLevelSpecialtiesActions.js